import styles from './styles.module.scss'
import LanderInvoiceEntry from './LanderInvoice'

const InvoiceEntry = () => {
  return (
    <div className={styles.main}>
      <LanderInvoiceEntry />
    </div>
  )
}

export default InvoiceEntry
import styles from './styles.module.scss'
import LanderInvoiceEntry from './LanderInvoice'

const InvoiceEntry = () => {
  return (
    <div className={styles.main}>
      <LanderInvoiceEntry />
    </div>
  )
}

export default InvoiceEntry
